import './App.css';
import Router from './Router';
import Providers from './Providers';

function App() {
	return (
		<div className="App">
			<Providers>
				<Router />
			</Providers>
		</div>
	);
}

export default App;
